<template>
  <v-container fluid pa-5>
    <p class="font-weight-medium my-0">อุบัติเหตุช่วง</p>
    <v-layout row wrap ma-0>
      <v-flex xs12>
        <v-layout row wrap ma-0 mt-2>
          <v-flex :class="[$vuetify.breakpoint.xsOnly ? 'xs5' : 'xs3']" pr-2>
            <DatePicker
              v-model="startDate"
              ref="startDate"
              :max="today"
              :defaultDate="lastmonth"
              @input="changeDate(utils.startDateChanged(startDate, endDate))"
            />
          </v-flex>
          <v-flex
            class="d-flex align-center justify-center"
            :class="[$vuetify.breakpoint.xsOnly ? 'xs2' : 'xs1']"
          >
            <p class="font-weight-medium my-0 mx-2">ถึง</p>
          </v-flex>
          <v-flex :class="[$vuetify.breakpoint.xsOnly ? 'xs5' : 'xs3']" pl-2>
            <DatePicker
              v-model="endDate"
              ref="endDate"
              :max="today"
              :defaultDate="utils.getLocalDate()"
              @input="changeDate(utils.endDateChanged(startDate, endDate))"
            />
          </v-flex>
        </v-layout>
        <v-row>
          <v-col xs="12" v-if="['ADMIN', 'SYSTEM'].indexOf(role) != -1">
            <p class="font-weight-medium my-0">หน่วยงาน</p>
            <v-select
              v-model="departmentSelect"
              :items="departmentItems"
              item-text="description"
              item-value="id"
              no-data-text="ไม่พบข้อมูล"
              label="เลือกหน่วยงาน"
              class="card-border"
              flat
              solo
              :chips="departmentMultiple"
              hide-details
              :multiple="departmentMultiple"
            >
              <template v-slot:selection="{ item }" v-if="departmentMultiple">
                <v-chip>
                  <span>{{ item.name_th }}</span>
                </v-chip>
                <!-- <span
                  v-if="index === 1"
                  class="grey--text caption"
                >(และอื่นๆ อีก {{ departmentSelect.length - 1 }} รายการ)</span> -->
              </template>
              <template v-slot:prepend-item v-if="departmentMultiple">
                <v-list-item ripple @click="toggleSelectAllDepartment">
                  <v-list-item-action>
                    <v-icon :color="departmentSelect.length > 0 ? 'primary base' : ''">{{
                      departmentSelecticon
                    }}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>เลือกทั้งหมด</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-select>
          </v-col>
        </v-row>

        <v-layout row wrap ma-0 align-end>
          <v-flex
            :class="[
              $vuetify.breakpoint.width <= 400 ? 'xs12' : 'xs6',
              $vuetify.breakpoint.width <= 400 ? 'pl-0 mt-4' : 'pl-2'
            ]"
            sm5
            pl-sm-0
            pr-0
            pr-sm-2
          >
            <p class="font-weight-medium my-0">จังหวัด</p>
            <v-select
              v-model="provinceSelect"
              :items="provinceItems"
              item-text="name"
              item-value="id"
              no-data-text="ไม่พบข้อมูล"
              label="เลือกจังหวัด"
              class="card-border"
              flat
              solo
              hide-details
            ></v-select>
          </v-flex>
          <v-flex xs12 sm5 pr-sm-2 mt-4 mt-sm-0>
            <p class="font-weight-medium my-0">สายทาง</p>
            <v-text-field
              v-model="searchText"
              label="สายทาง"
              class="card-border"
              flat
              solo
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm2 mt-4 mt-sm-0>
            <v-btn
              block
              rounded
              color="primary"
              class="order-0 order-sm-1"
              min-height="42"
              @click="search"
              >ค้นหา</v-btn
            >
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import DatePicker from '../global/DatePicker.vue';

export default {
  name: 'Search',
  components: {
    DatePicker
  },
  data: () => ({
    startDate: '',
    endDate: '',
    provinceSelect: '',
    departmentSelect: '',
    searchText: '',
    provinceItems: [],
    departmentItems: [],
    role: localStorage.getItem('role'),
    today: null
  }),
  props: {
    defaultDatefrommap: {
      type: Object,
      default: () => {
        return {};
      }
    },
    departmentMultiple: {
      type: Boolean,
      default: false
    }
  },
  created() {},
  mounted() {
    this.today = this.utils.getLocalDate();
    this.getDepartmentLists();
    this.getProvinceLists();
  },
  methods: {
    // init() {
    // if (this.defaultdate) {
    //   this.$refs.startDate.setDefaultData(this.defaultdate.substr(0,10));
    //   this.startDate = this.defaultdate.substr(0,10)
    // } else {
    //   this.startDate = this.lastMonthDate().substr(0,10);
    //   this.$refs.startDate.setDefaultData(this.startDate);
    // }
    // this.endDate = this.currentDate().substr(0,10);
    // this.$refs.endDate.setDefaultData(this.endDate);
    // },
    toggleSelectAllDepartment() {
      this.$nextTick(() => {
        if (this.selectAlldepartment) {
          this.departmentSelect = [];
        } else {
          this.departmentSelect = [];
          this.departmentItems.forEach(element => {
            this.departmentSelect.push(element.id);
          });
        }
      });
    },
    getDepartmentLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/department`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.departmentItems = response.data.data;
            if (scope.departmentItems.length > 0 && !scope.departmentMultiple)
              scope.departmentItems.unshift({
                id: 0,
                name: '',
                description: 'เลือกทุกหน่วยงาน'
              });
            this.search();
          }
        })
        .catch(function(error) {
          scope.departmentItems = [];
          console.log(error);
        });
    },
    getProvinceLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/province`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.provinceItems = response.data.data;
            if (scope.provinceItems.length > 0)
              scope.provinceItems.unshift({ id: 0, name: 'เลือกทุกจังหวัด' });
          }
        })
        .catch(function(error) {
          scope.provinceItems = [];
          console.log(error);
        });
    },
    search() {
      let departmentid = this.departmentSelect;
      if (['ADMIN', 'SYSTEM'].indexOf(this.role) == -1 && this.departmentItems) {
        const filterDepartment = this.departmentItems.filter(member => {
          return member.name == this.role;
        });
        if (filterDepartment.length) {
          departmentid = filterDepartment[0].id;
        }
      } else if (
        ['ADMIN', 'SYSTEM'].indexOf(this.role) != -1 &&
        this.departmentSelect &&
        this.departmentMultiple
      ) {
        departmentid = this.departmentSelect.join(',');
      }
      this.$emit('getSearchCondition', {
        keyword: this.searchText,
        start_date: this.startDate,
        end_date: this.endDate,
        department: departmentid,
        province: this.provinceSelect
      });
    },
    changeDate(period) {
      if (period) {
        if (period.startDate != this.startDate) {
          this.$refs.startDate.setDefaultData(period.startDate);
        }
        if (period.endDate != this.endDate) {
          this.$refs.endDate.setDefaultData(period.endDate);
        }
      }
    }
  },
  computed: {
    filter() {
      return this.searchFilter;
    },
    lastmonth() {
      const dt = new Date();
      dt.setMonth(dt.getMonth() - 1);
      return this.utils.getLocalDate(dt);
    },
    selectAlldepartment() {
      return this.departmentSelect.length === this.departmentItems.length;
    },
    selectSomedepartment() {
      return this.departmentSelect.length > 0 && !this.selectAlldepartment;
    },
    departmentSelecticon() {
      if (this.selectAlldepartment) return 'mdi-close-box';
      if (this.selectSomedepartment) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    }
  },
  watch: {
    defaultDatefrommap() {
      this.$refs.startDate.setDefaultData(this.defaultDatefrommap.start_date.substr(0, 10));
      this.$refs.endDate.setDefaultData(this.defaultDatefrommap.end_date.substr(0, 10));
      this.searchText = this.defaultDatefrommap.road;
      this.provinceSelect = this.defaultDatefrommap.province;
      this.departmentSelect = this.defaultDatefrommap.department.split(',');
    }
  }
};
</script>

<style lang="scss" scoped>
.card-border {
  margin-top: 8px;
}
</style>
